import React from 'react';
import PropTypes from 'prop-types';

import IconFollow from './svg/IconFollow';
import './ButtonFollow.css';

function ButtonFollow({ isFollow, onClick }) {  
  return isFollow
    ? (
      <div className={`small-button flexRow following-button`} onClick={onClick}>
        <IconFollow className={'icon-following'} />
        <span className={`type-medium fz13 text-following`} >Following</span>
        <span className={`type-medium fz13 text-unfollow`} >Unfollow</span>
      </div>
    )
    : (
      <div className={`small-button flexRow follow-button`} onClick={onClick}>
        <IconFollow className={'icon-follow'} />
        <span className={`type-medium fz13`} >Follow</span>
      </div>
    )
}

ButtonFollow.propTypes = {
  isFollow: PropTypes.bool.isRequired,
  onClick: PropTypes.func
}

export default ButtonFollow;
